import { useCallback, useMemo } from 'react'
import { allowedCommissionTypes } from 'pages/finance/commission/commission/CommissionEnums'
import AgreementCommissionStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/AgreementCommissionStageSteps'
import { BaseComplianceModalProps } from '../BaseComplianceModalProps'

const QldAgreementCommissionPage = ({
  task,
  toggleTaskStep,
  commissionDetails,
  currentCommissionInfo,
  setCommissionDetailsValid,
  onCommissionUpdated,
}: BaseComplianceModalProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps])

  if (!setCommissionDetailsValid || !onCommissionUpdated) {
    return null
  }

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked)
    },
    [toggleTaskStep]
  )

  const handleCommissionDetailsValid = useCallback(
    (valid: boolean) => {
      setCommissionDetailsValid(valid)

      const firstStep = taskSteps[0]
      if (firstStep && firstStep.isCompleted !== valid) {
        toggleTaskStep(firstStep.order ?? 0, valid)
      }
    },
    [setCommissionDetailsValid, taskSteps, toggleTaskStep]
  )

  return (
    <AgreementCommissionStageSteps
      commissionDetails={commissionDetails}
      onCommissionUpdated={onCommissionUpdated}
      allowedCommissionTypes={allowedCommissionTypes}
      currentCommissionInfo={currentCommissionInfo}
      tasksStage={taskSteps}
      updateTaskStep={updateTaskStep}
      setCommissionDetailsValid={handleCommissionDetailsValid}
    />
  )
}

export default QldAgreementCommissionPage
